"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.user_edit = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var user_edit = function user_edit(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'user-edit-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M6 5.75C6 3.67893 7.67893 2 9.75 2C11.8211 2 13.5 3.67893 13.5 5.75V6.75C13.5 8.13923 12.7446 9.35202 11.6221 10H11.75C12.308 10 12.8436 10.0962 13.3409 10.273L12.0957 11.5182C11.9821 11.5062 11.8668 11.5 11.75 11.5H7.75C5.95507 11.5 4.5 12.9551 4.5 14.75V17H7.15458L6.78171 18.5H3.75C3.33579 18.5 3 18.1642 3 17.75V14.75C3 12.1266 5.12665 10 7.75 10H7.87791C6.75543 9.35202 6 8.13923 6 6.75V5.75ZM14.2916 10.7365L13.1917 11.8364L8.23695 16.7911L8.18501 17L7.81214 18.5L7.75 18.75L8.75577 18.5L9.70897 18.2631L10.9721 17L14.6636 13.3085L15.7636 12.2085L17.3874 10.5848C17.8379 10.1343 17.8734 9.43937 17.4671 9.03308C17.0606 8.6266 16.3661 8.6621 15.9158 9.11237L14.2916 10.7365ZM10.8863 18.5L12.3863 17H15V14.75C15 14.6333 14.9938 14.518 14.9819 14.4045L16.2271 13.1593C16.4038 13.6566 16.5 14.1921 16.5 14.75V17.75C16.5 18.1642 16.1642 18.5 15.75 18.5H10.8863ZM9.75 3.5C8.50736 3.5 7.5 4.50736 7.5 5.75V6.75C7.5 7.99264 8.50736 9 9.75 9C10.9926 9 12 7.99264 12 6.75V5.75C12 4.50736 10.9926 3.5 9.75 3.5Z',
    fill: '#4B5563'
  }));
};

exports.user_edit = user_edit;